// extracted by mini-css-extract-plugin
module.exports = {"IconCog":"UserMainActions_IconCog__2cF_2","manuContainer":"UserMainActions_manuContainer__2fOvv"};